import { DrawerState } from './reducer';
// import { StateObservable } from 'redux-observable';

export const getOpened = (state: DrawerState) => state.opened